import React, {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faBars, faArrowRight, faHome} from '@fortawesome/fontawesome-free-solid'

class Navbar extends Component {
    render() {
        return (
            <div id="navbar-scroll" className="fixed z-50 top-0 w-full">
                <div className="bg-white/70 drop-shadow-lg select-none backdrop-blur-md backdrop-brightness-15">
                    <div className="flex flex-row mx-5 max-w-3xl">

                        <a href="/">
                            <img className="flex my-1 mx-2 w-20 md:w-15 h-auto transition ease-in-out hover:scale-110"
                                 src="https://i.imgur.com/vy7xdek.png"
                                 alt="logo.webp"/>
                        </a>

                        <div>
                            <a href onClick={toggleDropdown}
                               className="absolute right-5 my-6 mx-2 cursor-pointer rounded-lg px-4 py-2 font-bold hover:bg-black/20 min-[800px]:hidden">
                                <FontAwesomeIcon icon={faBars} className="w-5 h-auto text-gray-900"/>
                            </a>
                        </div>


                        <div className="flex flex-row justify-between xl:gap-48 p-2 my-4">

                            <ul className="flex flex-wrap gap-6 max-[800px]:hidden">
                                <li>
                                    <div
                                        className="cursor-pointer my-auto text-lg text-gray-900 rounded-lg px-4 py-2 font-bold hover:bg-black/20 transition duration-150 ease-out hover:ease-in">
                                        <a href="/">Startseite</a>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        className="cursor-pointer my-auto text-lg text-gray-900 rounded-lg px-4 py-2 font-bold hover:bg-black/20 transition duration-150 ease-out hover:ease-in">
                                        <a href="/newsletter">Newsletter</a>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        className="cursor-pointer my-auto text-lg text-gray-900 rounded-lg px-4 py-2 font-bold hover:bg-black/20 transition duration-150 ease-out hover:ease-in">
                                        <a href="/blogs">Blog</a>
                                    </div>
                                </li>
                                {/*<li>
                                    <div
                                        className="cursor-pointer my-auto text-gray-900 rounded-lg px-4 py-2 font-bold hover:bg-black/20 transition duration-150 ease-out hover:ease-in">
                                        <a href="https:///www.BlackNinja.Live/blog">Info</a>
                                    </div>
                                </li>*/}
                            </ul>
                        </div>

                        <div className="absolute right-24 max-[800px]:hidden ">
                            <a href="mailto:info@us-arbeitsrecht.de" className="flex right-12 ml-12 mt-7 h-10 bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded items-center">
                                <span>Jetzt anfragen</span>
                                <FontAwesomeIcon icon={faArrowRight}
                                                 className="w-4 ml-3 h-auto text-white animate-slideBouncing500"/>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="bg-slate-200 absolute inline-block rounded-l-lg rounded-bl-lg right-0 drop-shadow-lg min-[800px]:hidden">
                    <ul id="navbar-dropdown" className="navbar-dropdown-content">
                        <div className="p-5">
                            <li><a href="/" className="flex cursor-pointer text-gray-700 rounded-lg px-4 py-1 my-2 font-bold hover:bg-black/20 transition duration-150 ease-out hover:ease-in">Startseite</a></li>
                            <li><a href="/newsletter" className="flex cursor-pointer text-gray-700 rounded-lg px-4 py-1 my-2 font-bold hover:bg-black/20 transition duration-150 ease-out hover:ease-in">Newsletter</a></li>
                            <li><a href="/blogs" className="flex cursor-pointer text-gray-700 rounded-lg px-4 py-2 my-2 font-bold hover:bg-black/20 transition duration-150 ease-out hover:ease-in">Blog</a></li>
                            {/*<li><a href="/" className="flex cursor-pointer text-gray-700-white rounded-lg px-4 py-1 my-2 font-bold hover:bg-black/20 transition duration-150 ease-out hover:ease-in">Info</a></li>*/}
                            <div className="pt-6">
                                <a href="mailto:info@us-arbeitsrecht.de" className="p-12 bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded items-center">
                                    <span>Jetzt anfragen</span>
                                    <FontAwesomeIcon icon={faArrowRight}
                                                     className="w-4 ml-3 h-auto text-white animate-slideBouncing500"/>
                                </a>
                            </div>
                        </div>
                    </ul>
                </div>
            </div>
        );
    }
}

function toggleDropdown() {
    var dropdown = document.getElementById("navbar-dropdown");
    if (dropdown.className === "navbar-dropdown-content") {
        dropdown.className += " show";
    } else {
        dropdown.className = "navbar-dropdown-content";
    }
}

window.onscroll = function() {
    const element = document.getElementById("navbar-scroll");

    if (window.scrollY === 0) {
        element.classList.remove("fixed", "z-50", "top-0");
        element.classList.add("fixed", "z-50", "top-0");
    } else {
        element.classList.add("fixed", "z-50", "top-0");
    }
};

export default Navbar;